<div
  class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center px-3"
  style="z-index: 1050; background: rgba(0, 0, 0, 0.6)"
  (click)="close()"
>
  <div
    class="position-relative p-3 p-md-4 rounded-2 text-lightgray bg-card bg-dark border border-darkgray w-100"
    style="max-width: 680px; max-height: 90vh; overflow-y: auto"
    (click)="$event.stopPropagation()"
  >
    <span
      class="rb-ic rb-ic-close fs-2xl position-absolute top-2 end-2 cursor-pointer hover-effect"
      (click)="close()"
    ></span>

    @if (!reportSubmitted()) {
      <span class="fs-lg text-body-emphasis d-block mb-3">Report Sign Issue</span>

      <form #reportForm="ngForm" (ngSubmit)="reportForm.valid && submitReport()">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">Title <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control text-lightgray bg-darkgray border border-darkgray"
            data-cy="sign-report-title"
            maxlength="255"
            name="title"
            required
            pattern=".*\S.*"
            placeholder="Enter title"
            [(ngModel)]="report.title"
          />
        </div>

        <div class="col-md-6">
          <label class="form-label"
            >Occurrence Date &amp; Time <span class="text-danger">*</span></label
          >
          <input
            type="datetime-local"
            name="occurrenceDateTime"
            required
            class="form-control text-lightgray bg-darkgray border border-darkgray"
            data-cy="sign-report-datetime"
            [(ngModel)]="report.occurrenceDateTime"
          />
        </div>
        <div class="col-md-6">
          <label class="form-label">Problem Category <span class="text-danger">*</span></label>
          <select
            class="form-select text-lightgray bg-darkgray border border-darkgray"
            data-cy="sign-report-category"
            name="category"
            required
            [(ngModel)]="report.category"
          >
            <option value="" disabled>Select a category</option>
            @for (cat of issueCategories; track cat.value) {
              <option [value]="cat.value">{{ cat.label }}</option>
            }
          </select>
        </div>

        <div class="col-12">
          <label class="form-label">Description <span class="text-danger">*</span></label>
          <textarea
            class="form-control text-lightgray bg-darkgray border border-darkgray"
            rows="4"
            name="description"
            required
            pattern="[\s\S]*\S[\s\S]*"
            placeholder="Describe the problem..."
            data-cy="sign-report-description"
            [(ngModel)]="report.description"
          ></textarea>
        </div>
      </div>

      @if (reportForm.submitted && reportForm.invalid) {
        <div class="text-danger mt-3 small" role="alert">
          Enter a title, occurrence date and time, problem category, and description.
        </div>
      }
      @if (reportError()) {
        <div class="text-danger mt-3 small">Submission failed. Please try again.</div>
      }
      <div class="d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="rb-btn rb-btn-outline-secondary" (click)="close()">
          Cancel
        </button>
        <button
          type="submit"
          class="rb-btn rb-btn-outline-secondary"
          data-cy="sign-report-submit"
          [disabled]="reportSubmitting()"
        >
          {{ reportSubmitting() ? 'Submitting...' : 'Submit Report' }}
        </button>
      </div>
      </form>
    } @else {
      <div class="text-center py-4">
        <span class="rb-ic rb-ic-checkmark-frame fs-3xl text-success d-block mb-3"></span>
        <span class="fs-lg text-body-emphasis d-block mb-2" data-cy="sign-report-success"
          >Report submitted</span
        >
        <span class="text-lightgray d-block mb-2">Thank you for your feedback.</span>
        @if (ticketKey() && ticketUrl()) {
          <span class="d-block mb-4">
            <span class="text-lightgray">Ticket: </span>
            <a
              [href]="ticketUrl()"
              target="_blank"
              class="text-success"
              data-cy="sign-report-ticket-link"
              >{{ ticketKey() }}</a
            >
          </span>
        }
        <button
          type="button"
          class="rb-btn rb-btn-primary"
          data-cy="sign-report-close"
          (click)="close()"
        >
          Close
        </button>
      </div>
    }
  </div>
</div>
